import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { formatDateAsQuery } from 'src/helpers/UtilityHelper';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import { DefaultPageProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';
import { LinkButton } from 'src/components/atoms/button/Button';
import HomeButton from 'src/components/atoms/button/HomeButton';

type Props = DefaultPageProps;

const NotificationCompletePage = (props: Props) => {
  const { login_shop_id } = props;
  return (
    <DefaultLayout {...props}>
      <Styled>
        <div>
          <Heading>＼ 商品のお知らせ予約を承りました ／</Heading>
          <Lead>
            お客様には焼き上がり時刻に自動で
            <br />
            お知らせが届きます
            <br />
            販売する商品は、店頭に陳列せず
            <br />
            確保しておいてください
          </Lead>
          <Controller>
            <LinkButton
              isDisabled={false}
              url={`/shop/${login_shop_id}/search/order_breads/${formatDateAsQuery()}`}
              text={'最新の配信と注文状況を確認する'}
            />
            <HomeButton />
          </Controller>
        </div>
      </Styled>
    </DefaultLayout>
  );
};

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 52px);
`;

const Heading = styled.h3`
  color: ${StyleConfig.COLOR.PRIMARY};
  font-size: 18px;
  text-align: center;
`;
const Lead = styled.p`
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  font-size: 14px;
  line-height: ${24 / 14};
  text-align: center;
  margin-top: 16px;
`;
const Controller = styled.div`
  margin-top: 40px;
  > * {
    margin-top: 16px;
  }
`;

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCompletePage);
